import { Layout } from 'components/Layout'
import { CurrentUserContextProvider } from 'context/useCurrentUser'
import { StepperProvider } from './context/StepperContext'
import { ProjectStepper } from './components/ProjectStepper'
import { ProjectButtonsProvider } from './context/ProjectButtonsContext'

export const NewProject = () => {
  // O contexto de IA agora é gerenciado pelo StepperContext
  // Será limpo automaticamente quando o componente for desmontado
  
  return (
    <CurrentUserContextProvider>
      <Layout>
        <ProjectButtonsProvider>
          <StepperProvider>
            <ProjectStepper />
          </StepperProvider>
        </ProjectButtonsProvider>
      </Layout>
    </CurrentUserContextProvider>
  )
}
